import { DiscussionContextType, QUERY_KEYS } from "@cnx/common";
import { useQuery } from "@tanstack/react-query";
import DiscussionService from "services/DiscussionService";

export const useChatDiscussionContext = ({
  contextId,
  context,
}: {
  contextId?: string;
  context?: DiscussionContextType;
}) => {
  const enabled = !!context && !!contextId;

  const { data, isPending, isFetching, isFetched } = useQuery({
    queryKey: [QUERY_KEYS.DISCUSSION_CONTEXT, context, contextId],
    queryFn: () =>
      DiscussionService.getChatDiscussionContext({
        context: context!,
        contextId: contextId!,
      }),
    enabled,
    placeholderData: undefined,
  });

  return {
    discussionContext: data,
    isPending,
    isFetching: isFetching && !isFetched,
  };
};
